module.exports = __webpack_public_path__ + "img/gg.484c3faf.svg";